import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Observable, catchError, lastValueFrom, of, shareReplay, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { byPassError } from '../models/http-context.model';
import { User } from '../models/user.model';

@Injectable({
    providedIn: 'root',
})
export class SecurityService {
    private identity = signal(null as User | null);
    private backendUrl = `${environment.urlBackend}/api`;

    constructor(public http: HttpClient) { }

    me(): Observable<User> {
        return this.http.get<User>(`${this.backendUrl}/users/me`);
    }

    isAuthenticated(): Observable<boolean> {
        return this.http.get<boolean>(`${this.backendUrl}/users/authenticated`);
    }

    login(credentials: any): Observable<void> {
        return this.http.post<void>(`${this.backendUrl}/login-post`, credentials, { context: byPassError() });
    }

    logout(): Promise<void> {
        return lastValueFrom(
            this.http.post<void>(`${this.backendUrl}/logout`, {}, { context: byPassError() }).pipe(tap(() => this.identity.set(null))),
        );
    }

    authenticate(): Observable<User | null> {
        return this.me().pipe(
            catchError(() => {
                return of(null);
            }),
            tap((user: User | null) => {
                this.identity.set(user);
            }),
            shareReplay(),
        );
    }

    getUser(): User | null {
        return this.identity();
    }
}
